export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5227.ebc7fb0f.jpg";